import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import { useMobile } from './MobileContext';
import { useTheme } from './ThemeContext';
import './LeaguePicker.css';

const LeaguePicker = ({ onSelectLeagues, width, isMultiSelect }) => {
    const isMobile = useMobile();
    const { isDarkMode } = useTheme();
    const leagueButtonClass = isMobile ? 'league-button-mobile' : '';
    const leagueTextClass = isMobile ? 'd-flex-mobile' : 'd-flex';
    const leagueGroupClass = isMobile ? 'league-group-mobile' : 'league-group';

    const [selectedLeagues, setSelectedLeagues] = useState([]);

    const soccerLeagues = ['BUND', 'EPL', 'LIGUE', 'SERA', 'LALIGA', 'FIFA'];

    const handleLeagueSelection = (shortName) => {
        let updatedLeagues = [];

        if (isMultiSelect) {
            if (shortName === 'FIFA') {
                updatedLeagues = selectedLeagues.includes('FIFA')
                    ? selectedLeagues.filter((league) => !soccerLeagues.includes(league))
                    : [...selectedLeagues, ...soccerLeagues.filter((league) => !selectedLeagues.includes(league))];
            } else if (shortName.includes('NCAA')) {
                updatedLeagues = selectedLeagues.includes(shortName)
                    ? selectedLeagues.filter((league) => league !== shortName)
                    : [...selectedLeagues, shortName];
            } else {
                updatedLeagues = selectedLeagues.includes(shortName)
                    ? selectedLeagues.filter((league) => league !== shortName)
                    : [...selectedLeagues, shortName];
            }
        } else {
            updatedLeagues = shortName === 'FIFA' ? soccerLeagues : [shortName];
        }

        setSelectedLeagues(updatedLeagues);
        onSelectLeagues(updatedLeagues);
    };

    const isLeagueSelected = (shortName) => selectedLeagues?.includes(shortName);

    return (
        <ButtonGroup className={leagueGroupClass}>
            {[
                { name: 'NFL', icon: <SportsFootballIcon /> },
                { name: 'NBA', icon: <SportsBasketballIcon /> },
                { name: 'NHL', icon: <SportsHockeyIcon /> },
                { name: 'MLB', icon: <SportsBaseballIcon /> },
                { name: 'NCAAF', icon: <SportsFootballIcon /> },
                { name: 'NCAAB', icon: <SportsBasketballIcon /> },
                { name: 'FIFA', icon: <SportsSoccerIcon /> },
            ].map(({ name, icon }) => (
                <Button
                    key={name}
                    variant={isLeagueSelected(name) ? 'primary' : 'secondary'}
                    onClick={() => handleLeagueSelection(name)}
                    className={leagueButtonClass}
                    style={{
                        background: isLeagueSelected(name) ? 'var(--accent-primary)' : 'var(--bg-tertiary)',
                        color: isLeagueSelected(name) ? 'var(--text-inverse)' : 'var(--text-secondary)',
                        border: `1px solid ${isLeagueSelected(name) ? 'var(--accent-primary)' : 'var(--border-primary)'}`,
                        transition: 'all 0.3s ease'
                    }}
                >
                    {React.cloneElement(icon, { 
                        style: { 
                            fontSize: width,
                            color: isLeagueSelected(name) ? 'var(--text-inverse)' : 'var(--text-secondary)'
                        } 
                    })}
                    <div 
                        className={leagueTextClass} 
                        style={{ 
                            color: isLeagueSelected(name) ? 'var(--text-inverse)' : 'var(--text-secondary)',
                            transition: 'color 0.3s ease'
                        }}
                    >
                        {name}
                    </div>
                </Button>
            ))}
        </ButtonGroup>
    );
};

export default LeaguePicker;
